import Vue from 'vue'
import store from './store'
import config from './config'
import './plugins/vuetify'
import AsyncComputed from 'vue-async-computed'
import VeeValidate from 'vee-validate'
import VueSweetalert2 from 'vue-sweetalert2'
import VueCurrencyFilter from 'vue-currency-filter'
import 'roboto-fontface/css/roboto/roboto-fontface.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import 'font-awesome/css/font-awesome.css'
import Truncate from 'lodash.truncate';
import moment from 'moment';


// Helpers
// Global filters
Vue.filter('truncate', Truncate);
Vue.config.productionTip = false;
Vue.use(VeeValidate, { fieldsBagName: 'formFields' });
Vue.use(VueSweetalert2);
Vue.use(AsyncComputed);
Vue.use(VueCurrencyFilter, {
    symbol : '',
    thousandsSeparator: '.',
    fractionCount: 0,
    fractionSeparator: ',',
    symbolPosition: 'front',
    symbolSpacing: true
});
Vue.prototype.$config = config;
Vue.prototype.$moment = moment;

const apps   = config ? config.apps : 'main';
const App    = () => import('@/apps/'+ apps +'/App.vue');
const Router = import('@/apps/'+ apps +'/router/index.js');

Router.then(res => {   
    let router = res.default;         
    new Vue({  
        router,
        store,
        render: h => h(App)
    }).$mount('#app');
})

